const IMAGE_URL_BASE = 'https://new-thingdoms.s3.us-east-1.amazonaws.com';
const PFPS_URL_BASE = 'https://thingdoms-pfps.s3.eu-west-2.amazonaws.com';
export const THINGS_IMAGE_URL = `${PFPS_URL_BASE}/compressed_images`;
export const THINGS_THUMB_IMAGE_URL = `${IMAGE_URL_BASE}/full_1000x1000/original`;
export const THINGS_REMASTERED_IMAGE_URL = `${IMAGE_URL_BASE}/full_1000x1000/original`;
export const THINGS_PIXELATED_IMAGE_URL = `${IMAGE_URL_BASE}/full_1000x1000/pixel`;
export const THINGS_THUMB_PIXELATED_IMAGE_URL = `${IMAGE_URL_BASE}/thumbnails_150x150/pixel`;
export const SIGNALS_IMAGE_URL = `${IMAGE_URL_BASE}/full_1000x1000/signals`;
export const SIGNALS_THUMB_IMAGE_URL = `${IMAGE_URL_BASE}/thumbnails/signals`;

export const getImageUrl = (tokenId) => {
  return `${THINGS_IMAGE_URL}/${tokenId}.jpeg`;
};

export const getRemasteredImageUrl = (tokenId) => {
  return `${THINGS_REMASTERED_IMAGE_URL}/${tokenId}.png`;
};

export const getThumbnailImageUrl = (tokenId) => {
  return `${THINGS_THUMB_IMAGE_URL}/${tokenId}.png`;
};

export const getPixelatedImageUrl = (tokenId) => {
  return `${THINGS_PIXELATED_IMAGE_URL}/${tokenId}.gif`;
};

export const getThumbnailPixelatedImageUrl = (tokenId) => {
  return `${THINGS_THUMB_PIXELATED_IMAGE_URL}/${tokenId}.gif`;
};

export const getSignalUrl = (tokenId, fileType) => {
  return `${SIGNALS_IMAGE_URL}/${tokenId}.${fileType}`;
};

export const getSignalThumbnailImageUrl = (tokenId) => {
  return `${SIGNALS_THUMB_IMAGE_URL}/${tokenId}.webp`;
};

export const padZeros = (number) => {
  return number.toString().padStart(4, '0');
};

export function numberToWords(n) {
  if (n === 0) return 'ZERO';

  const ones = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN',
                'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'];
  const tens = ['', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];

  function convertBelow1000(num) {
    if (num === 0) return '';
    if (num < 20) return ones[num];
    if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? '-' + ones[num % 10] : '');
    return ones[Math.floor(num / 100)] + ' HUNDRED' + (num % 100 ? ' AND ' + convertBelow1000(num % 100) : '');
  }

  if (n < 1000) return convertBelow1000(n);
  const remainder = n % 1000;
  if (remainder === 0) return convertBelow1000(Math.floor(n / 1000)) + ' THOUSAND';
  const join = remainder < 100 ? ' AND ' : ' ';
  return convertBelow1000(Math.floor(n / 1000)) + ' THOUSAND' + join + convertBelow1000(remainder);
}
